export default [
  'AT',
  'BE',
  'CA',
  'CH',
  'CN',
  'DE',
  'DK',
  'ES',
  'FI',
  'FR',
  'IT',
  'LU',
  'NL',
  'NO',
  'PT',
  'US',
  'SE',
];
